import { create } from 'zustand'
import type { User, Workspace } from '@/lib/types'

interface AuthState {
  user: User | null
  workspace: Workspace | null
  hydrated: boolean
  setSession: (user: User, workspace: Workspace) => void
  clear: () => void
  markHydrated: () => void
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  workspace: null,
  hydrated: false,
  setSession: (user, workspace) => set({ user, workspace }),
  clear: () => set({ user: null, workspace: null }),
  markHydrated: () => set({ hydrated: true }),
}))
